var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16OtherBetsFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 5.33301L10.5359 7.17567M7.99992 5.33301L5.46392 7.17567M7.99992 5.33301V3.33301M10.5359 7.17567L9.56725 10.157H6.43325M10.5359 7.17567L12.3333 6.33301M5.46392 7.17567L6.43325 10.157M5.46392 7.17567L3.66659 6.33301M7.99992 3.33301L5.74925 1.72234M7.99992 3.33301L10.2506 1.72234M12.3333 6.33301L14.6333 8.66634M12.3333 6.33301L12.9999 3.58967M6.43325 10.157L5.33325 11.6663M9.56792 10.157L10.6666 11.6663M10.6666 11.6663L13.7746 11.333M10.6666 11.6663L8.99992 14.5917M5.33325 11.6663L2.22525 11.333M5.33325 11.6663L6.99992 14.5917M3.66659 6.33301L1.36659 8.66634M3.66659 6.33301L2.99992 3.58967M14.6666 7.99967C14.6666 11.6817 11.6819 14.6663 7.99992 14.6663C4.31792 14.6663 1.33325 11.6817 1.33325 7.99967C1.33325 4.31767 4.31792 1.33301 7.99992 1.33301C11.6819 1.33301 14.6666 4.31767 14.6666 7.99967Z",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16OtherBetsFootball);
export default __webpack_public_path__ + "static/media/kbv-v16-other-bets-football.c6e9df9078e6bfee5d980a7725e76ff8.svg";
export { ForwardRef as ReactComponent };